import { useState, useMemo } from "react"
import { config } from "../../config"
import { useParams } from "react-router"
import Wordsearch from "../../components/games/wordsearch/Wordsearch"
import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"
import { useSteps } from "../../hooks/useSteps"
import { ModalGanaste } from "../../components/games/ModalGanaste"
import { ElegirTag } from "../../components/games/ElegirTag"
import { GoBackBtn } from "../../components/games/GoBackBtn"
import { api } from "../../services/api"
import { ElegirMode } from "../../components/games/ElegirMode"
import { Breadcrumb } from "../../components/ui/Breadcrumb"
import { dificultades, tamanos } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { ModalError } from "../../components/ui/modal/ModalError"
import { useTranslation } from "react-i18next"

const ElegirDificultad = ({ hasImages = false, setDificultad }) => {
  const { t } = useTranslation()

  const handleClick = (code) => {
    setDificultad(code)
  }

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_a_difficulty`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="row">
          {dificultades
            .filter((dificultad) => dificultad.code !== "imgs" || hasImages)
            .map((dificultad, ix) => (
              <div key={ix} className="col-lg-4 col-6 py-1">
                <div
                  className="box category"
                  onClick={() => handleClick(dificultad.code)}>
                  <span>
                    {t(`games.wordsearch.difficulties.${dificultad.code}.name`)}
                  </span>
                  <span>
                    <b>
                      {t(
                        `games.wordsearch.difficulties.${dificultad.code}.difficulty`
                      )}
                    </b>
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

const ElegirCantPalabras = ({ setCantPalabras }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_words_number`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}>
          {tamanos.map((tam, ix) => (
            <div key={ix} className="col-lg-3 col-6 py-1">
              <div
                className="box category"
                onClick={() => setCantPalabras(tam)}>
                <span>{tam}</span>
                <span>
                  <b>{t(`ui.games.sizes.${tam}`)}</b>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

const ElegirOrientaciones = ({ setOrientaciones }) => {
  let orientations = [
    "horizontal",
    "vertical",
    "diagonal",
    "horizontalBack",
    "verticalUp",
  ]

  const { t } = useTranslation()

  const disabled = ["horizontal", "vertical"]

  const [oris, setOris] = useState(disabled)

  const toggleOri = (val) => {
    if (disabled.includes(val)) return

    if (oris.includes(val))
      setOris((currents) => currents.filter((item) => item !== val))
    else setOris((currents) => [...currents, val])
  }

  const boxStyle = { position: "relative", marginLeft: "0", marginRight: "0" }

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_orientation`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="row">
          {orientations.map((ori, ix) => {
            let bstyle = disabled.includes(ori)
              ? { ...boxStyle, ...{ opacity: 0.3, cursor: "not-allowed" } }
              : boxStyle

            let tick = oris.includes(ori) ? (
              <span style={{ position: "absolute", left: 0, margin: "0 20px" }}>
                ✅
              </span>
            ) : null

            return (
              <div key={ix} className="col-4 py-1">
                <div
                  className="box category"
                  style={bstyle}
                  onClick={toggleOri.bind(this, ori)}>
                  {tick}
                  <span>
                    <b>{t(`ui.games.orientations.${ori}`)}</b>
                  </span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <button className="btn vacio mt-5" onClick={() => setOrientaciones(oris)}>
        {t("games.wordsearch.next")}
      </button>
    </>
  )
}

const WordsearchLoader = ({
  tag,
  difficulty,
  size,
  orientations,
  winCallback,
}) => {
  const { t } = useTranslation()
  const { url, opt } = useMemo(
    () =>
      api.games.Wordsearch.Generate({
        tag,
        size,
        orientations,
        difficulty,
      }),
    [tag, size, orientations, difficulty]
  )

  const [data, isPending, err] = useFetch({ url, opt })
  const showErr = useState(true)

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t("ui.btns.loading")}...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <Wordsearch difficulty={difficulty} data={data} winCallback={winCallback} />
  )
}

const RandomWordsearch = () => {
  // estado del componente
  let [steps] = useSteps([
      "mode",
      "tag",
      "dificultad",
      "cantPalabras",
      "orientaciones",
      "images",
    ]),
    setMode = steps.setter("mode"),
    setTag = steps.setter("tag"),
    setDificultad = steps.setter("dificultad"),
    setCantPalabras = steps.setter("cantPalabras"),
    setOrientaciones = steps.setter("orientaciones"),
    setImages = steps.setter("images")

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    },
    alAzarCallback = () => {
      const { url, opt } = api.tags.readAll({})
      fetch(url, opt)
        .then((res) => res.json())
        .then((data) => {
          let rTag =
            data.entries[Math.floor(Math.random() * data.entries.length)]
          // notar que lo lleno en orden reverso
          setOrientaciones(["horizontal", "vertical"]) // <- lo dejo en default
          setCantPalabras(8) // <- lo dejo en default
          setDificultad("clues") // <- lo dejo en default
          setTag(rTag.name)
          setMode("random")
        })
    }

  const { t } = useTranslation()

  return (
    <>
      <ModalGanaste show={showModalGanaste} steps={steps} />

      <GoBackBtn steps={steps} />

      {steps.at("mode") && (
        <ElegirMode
          title={t(`games.wordsearch.title`)}
          setMode={setMode}
          alAzarCallback={alAzarCallback}
        />
      )}

      {steps.at("tag") && (
        <ElegirTag setTag={setTag} setHasImages={setImages} />
      )}

      {steps.at("dificultad") && (
        <ElegirDificultad
          hasImages={steps.data.images}
          setDificultad={setDificultad}
        />
      )}

      {steps.at("cantPalabras") && (
        <ElegirCantPalabras setCantPalabras={setCantPalabras} />
      )}

      {steps.at("orientaciones") && (
        <ElegirOrientaciones setOrientaciones={setOrientaciones} />
      )}

      {steps.done && (
        <>
          <WordsearchLoader
            tag={steps.data.tag}
            difficulty={steps.data.dificultad}
            size={steps.data.cantPalabras}
            orientations={steps.data.orientaciones}
            winCallback={handleWin}
          />

          <div className="d-flex flex-row justify-content-center my-4">
            <Breadcrumb
              entries={[
                "Wordsearch",
                steps.data.tag,
                steps.data.dificultad,
                `${steps.data.cantPalabras}x${steps.data.cantPalabras}`,
                steps.data.orientaciones
                  .reduce((cur, acc) => `${acc} + ${cur}`, "")
                  .slice(0, -2),
              ]}
            />
          </div>
        </>
      )}
    </>
  )
}

const WordsearchID = ({ uid }) => {
  const { t } = useTranslation()
  const [data, isPending, err] = useFetch({
    url: `${config.apiUrl}/games/${uid}`,
  })

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    }

  const showErr = useState(true)

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t("ui.btns.loading")}...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <>
      <ModalGanaste show={showModalGanaste} />
      {data && (
        <Wordsearch
          difficulty={data.diff}
          data={data}
          winCallback={handleWin}
        />
      )}
    </>
  )
}

const WordsearchView = () => {
  const { uid } = useParams()

  return (
    <Container>
      {uid ? <WordsearchID uid={uid} /> : <RandomWordsearch />}
    </Container>
  )
}

export default WordsearchView
